<app-cover-design-asset
  [gallery]="gallery()"
  [theme]="theme()"
  [previewAsset]="previewAsset()"
  [noAsset]="noAsset()"
></app-cover-design-asset>
<div [appApplyTypographyStyles]="[theme().cover.title_typography]" [class.animated]="animated()"></div>
